export enum applicantDecideTypes {
  FETCH_APPLICANT_DECIDE_REQUEST = "FETCH_APPLICANT_DECIDE_REQUEST",
  FETCH_APPLICANT_DECIDE_SUCCESS = "FETCH_APPLICANT_DECIDE_SUCCESS",
  FETCH_APPLICANT_DECIDE_FAILURE = "FETCH_APPLICANT_DECIDE_FAILURE",
}